import React, { useEffect, useState } from 'react';

const initialScorecard = [
  {
    partner: "NFL.com",
    messaging: "All Messaging",
    rfpBudget: "$400,000",
    summary: "Homepage Takeover, ROS Display, ROS Pre-roll, Organic Social Post, High Impact ROS Display",
    studiesMeasurement: "In Market & DV Fees",
    pricingCPM: "~15/$18 CPM",
    efficiency: "3",
    targeting: "3",
    creativeImpact: "3",
    abilityToTrack: "2",
    addedValue: "3",
    preferredPartner: "1",
    averageScore: "2.5",
    hasData: true
  },
  {
    partner: "Yelp",
    messaging: "Core & Evergreen Messaging",
    rfpBudget: "$300,000",
    summary: "$450k - (Rooty Tooty, Omelets, Pancake of the Month, IHH, IHOPN'Go, Store Visit) - $30k added value YA $350k - (Profiles, Rooty Tooty, Omelets and Pancake of the Month)",
    studiesMeasurement: "InMarket Store Visits, Foursquare Store Visit, Kantar BLS",
    pricingCPM: "~$17/$22 CPM",
    efficiency: "3",
    targeting: "3",
    creativeImpact: "3",
    abilityToTrack: "2",
    addedValue: "3",
    preferredPartner: "0",
    averageScore: "2.3",
    hasData: true
  },
  {
    partner: "ESPN",
    hasData: false
  }
];

export function RFPScorecard() {
  const [scorecard, setScorecard] = useState(() => {
    // Try to load existing scorecard from localStorage
    const savedScorecard = localStorage.getItem('rfpScorecard');
    if (savedScorecard) {
      return JSON.parse(savedScorecard);
    }
    
    // If no saved data, use initial data
    localStorage.setItem('rfpScorecard', JSON.stringify(initialScorecard));
    return initialScorecard;
  });

  useEffect(() => {
    // Check for any new partners to add from the consideration set
    const newPartners = JSON.parse(localStorage.getItem('scorecardPartners') || '[]');
    if (newPartners.length > 0) {
      setScorecard(currentScorecard => {
        const updatedScorecard = [...currentScorecard];
        
        // Add any new partners that aren't already in the scorecard
        newPartners.forEach(newPartner => {
          if (!updatedScorecard.some(row => row.partner === newPartner.partner)) {
            updatedScorecard.push(newPartner);
          }
        });
        
        // Save to localStorage
        localStorage.setItem('rfpScorecard', JSON.stringify(updatedScorecard));
        return updatedScorecard;
      });
      
      // Clear the consideration set after adding partners
      localStorage.removeItem('scorecardPartners');
    }
  }, []); // Empty dependency array since we're using the functional update form

  // Save scorecard whenever it changes
  useEffect(() => {
    localStorage.setItem('rfpScorecard', JSON.stringify(scorecard));
  }, [scorecard]);

  return (
    <main className="main-content">
      <h1 className="page-title">Digital RFP Scorecard</h1>

      <div className="scorecard-actions">
        <button className="button-primary">
          Upload Scorecard
        </button>
        <button className="button-primary">
          + Add Weighted Average
        </button>
      </div>

      <div className="table-container">
        <table className="recommendations-table scorecard-table">
          <thead>
            <tr>
              <th>Partner</th>
              <th>Average Score</th>
              <th>Messaging</th>
              <th>RFP Budget</th>
              <th>Summary</th>
              <th>Studies/ Measurement</th>
              <th>Pricing / CPM</th>
              <th>Efficiency</th>
              <th>Targeting</th>
              <th>Creative Impact</th>
              <th>Ability to Track CPIV & CPO</th>
              <th>Added Value</th>
              <th>Preferred Partner / Corporate Deal</th>
              <th>Average Score</th>
            </tr>
          </thead>
          <tbody>
            {scorecard.map((row, index) => (
              <tr key={index}>
                <td>{row.partner}</td>
                {row.hasData ? (
                  <>
                    <td>{row.averageScore}</td>
                    <td>{row.messaging}</td>
                    <td>{row.rfpBudget}</td>
                    <td>{row.summary}</td>
                    <td>{row.studiesMeasurement}</td>
                    <td>{row.pricingCPM}</td>
                    <td>{row.efficiency}</td>
                    <td>{row.targeting}</td>
                    <td>{row.creativeImpact}</td>
                    <td>{row.abilityToTrack}</td>
                    <td>{row.addedValue}</td>
                    <td>{row.preferredPartner}</td>
                    <td>{row.averageScore}</td>
                  </>
                ) : (
                  <td colSpan="13" className="send-rfp-cell">
                    <button className="button-primary">
                      Send RFP
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </main>
  );
} 